import { UAParser } from 'ua-parser-js'

export const getUserAgent = (): IResult => new UAParser(navigator.userAgent).getResult()

// copied here because tsdown errored: Import `IResult` will always be undefined because there is no matching export in '../../../node_modules/.pnpm/ua-parser-js@2.0.3/node_modules/ua-parser-js/src/main/ua-parser.d.ts'
interface IBrowser {
  name?: string
  version?: string
  major?: string
  type?: string
}

interface IEngine {
  name?: string
  version?: string
}

interface ICPU {
  architecture?: string
}

interface IDevice {
  type?: string
  vendor?: string
  model?: string
}

interface IOS {
  name?: string
  version?: string
}

interface IResult {
  ua: string
  browser: IBrowser
  cpu: ICPU
  device: IDevice
  engine: IEngine
  os: IOS
}
